import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { handleGetRequest } from "../../../services/GetTemplate";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
/* eslint-disable */

const AddEditModule = ({ onHide, editable, roleRightsRowData, getRoleRights, roleId }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [menuOptions, setmenuOptions] = useState([]);

    useEffect(() => {
        if (roleRightsRowData !== null) {
            const rowData = JSON.parse(JSON.stringify(roleRightsRowData));
            const keys = Object.keys(rowData);
            keys.forEach((item) => {
                formik.setFieldValue(`${item}`, rowData[item]);
            });
            formik.setFieldValue("menuId", { id: rowData?.tblMenu?.menuId?.toString(), description: rowData?.tblMenu?.menuName, code: rowData?.tblMenu?.menuCode?.toString(), longText: null, shortText: null });
        }
    }, [roleRightsRowData]);

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovMenu").then((res) => {
            setmenuOptions(res?.data);
        });
    }, []);

    const menuTypeOptions = [
        { label: "Yes", value: "Y" },
        { label: "No", value: "N" },
    ];

    const validationSchema = Yup.object().shape({
        menuId: Yup.mixed().required("This field is required."),
        authorizeAllowed: Yup.string().required("This field is required."),
        hideYn: Yup.string().required("This field is required."),
        insertAllowed: Yup.string().required("This field is required."),
        selectAllowed: Yup.string().required("This field is required."),
        updateAllowed: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            authorizeAllowed: "",
            hideYn: "",
            insertAllowed: "",
            selectAllowed: "",
            updateAllowed: "",
            menuId: "",
        },

        onSubmit: async (data) => {
            delete data["tblMenu"]
            delete data["tblRole"]
            delete data["createdate"]
            delete data["createuser"]
            delete data["updateindex"]
            delete data["lastupdatedate"]
            delete data["lastupdateuser"]
            try {
                setloading(true);
                data["roleId"] = roleId;
                data["menuId"] = data?.menuId?.id;

                setloadingIcon("pi pi-spin pi-spinner");
                if (editable === true) {
                    await handlePutRequest(data, `zbizgateway/nonFin/updateRoleRights`);
                } else {
                    await handlePostRequest(data, "zbizgateway/nonFin/saveRoleRights");
                }
                await getRoleRights();
                onHide();

                formik.resetForm();
            } catch (error) {
                console.error("error", error)
            }
            finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round dialog_card">

                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="roleId" className={classNames({ "p-error": isFormFieldValid("menuId") }, "Label__Text")}>
                                    Menu<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="menuId" placeholder="" options={menuOptions} optionLabel="description" name="menuId" value={formik.values.menuId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("menuId") }, "Dropdown__Round")} />
                                {getFormErrorMessage("menuId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="authorizeAllowed" className={classNames({ "p-error": isFormFieldValid("authorizeAllowed") }, "Label__Text")}>
                                    Authorize Allowed<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="authorizeAllowed"
                                    placeholder=""
                                    options={menuTypeOptions}
                                    optionLabel="label"
                                    name="authorizeAllowed"
                                    value={formik.values.authorizeAllowed}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("authorizeAllowed") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("authorizeAllowed")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="hideYn" className={classNames({ "p-error": isFormFieldValid("hideYn") }, "Label__Text")}>
                                    Hidden Allowed<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="hideYn" placeholder="" options={menuTypeOptions} optionLabel="label" name="hideYn" value={formik.values.hideYn} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("hideYn") }, "Dropdown__Round")} />
                                {getFormErrorMessage("hideYn")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="insertAllowed" className={classNames({ "p-error": isFormFieldValid("insertAllowed") }, "Label__Text")}>
                                    Insert Allowed<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="insertAllowed"
                                    placeholder=""
                                    options={menuTypeOptions}
                                    optionLabel="label"
                                    name="insertAllowed"
                                    value={formik.values.insertAllowed}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("insertAllowed") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("insertAllowed")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="selectAllowed" className={classNames({ "p-error": isFormFieldValid("selectAllowed") }, "Label__Text")}>
                                    Select Allowed<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="selectAllowed"
                                    placeholder=""
                                    options={menuTypeOptions}
                                    optionLabel="label"
                                    name="selectAllowed"
                                    value={formik.values.selectAllowed}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("selectAllowed") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("selectAllowed")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="updateAllowed" className={classNames({ "p-error": isFormFieldValid("updateAllowed") }, "Label__Text")}>
                                    Update Allowed<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="updateAllowed"
                                    placeholder=""
                                    options={menuTypeOptions}
                                    optionLabel="label"
                                    name="updateAllowed"
                                    value={formik.values.updateAllowed}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("updateAllowed") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("updateAllowed")}
                            </div>
                        </div>
                    </div>
                    <div className="Top__Btn">
                        <Button disabled={loading} label={editable ? "Update" : "Add"} className="Add_New mr-0" />
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddEditModule;
